import React from "react";

import SettingsIcon from "@uui/Settings04";

import { Typography } from "@mui/material";

import { FloatingNavButton } from "@app/analytics/components/reports/FloatingNav";
import useVideoStore from "@app/analytics/MeetingReport/stores/video";
import useAnchorElement from "@app/utils/hooks/useAnchorElement";

import Menu, { MenuBody, MenuHeader } from "@rui/Menu";
import { Row } from "@rui/Stack";
import Switch from "@rui/Switch";
import TooltipIcon from "@rui/TooltipIcon";
import TooltipWrapper from "@rui/TooltipWrapper";

const CoachingSettings = () => {
  const { anchorElement, onClick, open, onClose } = useAnchorElement();

  const { playbackEnabled, autoPlay, toggleAutoPlay } = useVideoStore(
    (state) => ({
      playbackEnabled: state.playbackEnabled,
      autoPlay: state.autoPlay,
      toggleAutoPlay: state.toggleAutoPlay,
    })
  );

  return (
    <>
      <TooltipWrapper placement="bottom" title="Settings">
        <FloatingNavButton Icon={SettingsIcon} onClick={onClick} active={open}>
          Settings
        </FloatingNavButton>
      </TooltipWrapper>
      <Menu
        open={open}
        onClose={onClose}
        anchorEl={anchorElement}
        disablePadding
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuHeader>
          <SettingsIcon />
          <span>Settings</span>
        </MenuHeader>
        <MenuBody spacing={2}>
          <Row variant="apart" spacing={3}>
            <Row variant="left" spacing={1}>
              <Typography sx={{ whiteSpace: "nowrap" }}>
                Auto-play video
              </Typography>
              <TooltipIcon
                placement="bottom"
                title="Video will automatically play when clicking on moments"
              />
            </Row>
            <Switch
              checked={playbackEnabled && autoPlay}
              disabled={!playbackEnabled}
              onChange={toggleAutoPlay}
            />
          </Row>
        </MenuBody>
      </Menu>
    </>
  );
};

export default CoachingSettings;
